import {createStore} from 'zustand/vanilla';
import type {JourneyScheduleData} from '#types/journeys.js';

export type JourneySettingsState = {
  settings: JourneyScheduleData;
  setSettings: (settings: JourneyScheduleData) => void;
};

export const settingsStore = createStore<JourneySettingsState>()(set => ({
  settings: {
    schedule_type: null,
    frequency: null,
    start_type: null,
    start_time: null,
    end_type: null,
    end_time: null,
  },

  setSettings(settings: JourneyScheduleData) {
    set(state => ({
      ...state,
      settings: {
        ...state.settings,
        ...settings,
      },
    }));
  },
}));
